import {useCallback, useContext, useMemo, useRef} from 'react';
import {getEditorConfig} from '../../../../../Form/components/HTMLFormEditor/Editor/editorConfig';
import {EMAIL_EDITOR} from '../../constants';
import {LexicalEditor} from 'lexical';
import {useEmailContext} from '../../../../context';
import {useCustomClipboardCommands} from './useCustomClipboardCommands';
import {RuleDialogContext} from '../../../../../Automations/components/RulesListDialog/context';

export const useEditor = () => {
    const {
        handlers: {updateEmailEditor, updateEmailHTML, setFocusSubject},
        states
    } = useEmailContext();

    const {newEmailTemplate} = useContext(RuleDialogContext);

    const editorDivRef = useRef<HTMLDivElement>(null);
    const editorRef = useRef<LexicalEditor>();

    const editorConfig = useRef(getEditorConfig(EMAIL_EDITOR));

    const {closeContextMenu, contextMenuComponent, handleContext} = useCustomClipboardCommands({
        editor: editorRef.current
    });

    const setEditorInstance = useCallback(
        (editor: LexicalEditor) => {
            editorRef.current = editor;
            updateEmailEditor(editor);
        },
        [states.language, states.emailEditor]
    );

    const listitem = useMemo(() => {
        return states.language === '1'
            ? 'priority-editor__list-item-right'
            : 'priority-editor__list-item';
    }, [states.language]);

    return {
        editorDivRef,
        setEditorInstance,
        contextMenuComponent,
        closeContextMenu,
        handleContext,
        editorConfig,
        updateEmailHTML,
        states,
        editorRef,
        listitem,
        setFocusSubject,
        isFromTextEditor: !!newEmailTemplate
    } as const;
};
